// checks if is e2e test or other automated process
export const isBrowserWebdriver = () =>
  typeof window === 'object' &&
  typeof window?.navigator?.webdriver === 'boolean' &&
  window?.navigator?.webdriver;
